import { handleActions } from "redux-actions";
import actionCreators from "../../actions/top/index_of_not_signed_in";

const initialState = {
  isWebViewTabApp: false,
  circles: [],
  newArrivalCircles: [],
  events: [],
  blogs: [],
  reports: [],
  userAgent: "pc",
};

export default handleActions(
  {
    [actionCreators.top.indexOfNotSignedIn.set]: (state, action) =>
      Object.assign({}, state, action.payload),
  },
  initialState
);
